import React, { Component } from 'react'
import './Login.css'
import AuthenticationService from './AuthenticationService'
import { Config } from '../../Config'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { CommonConstants } from '../../Constants'
import Api from '../../Api'
import requestIp from 'ip'
import CommonLoader from '../Alerts/CommonLoader'
class Login extends Component {
  constructor () {
    super()
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      errorMessage: [],
      path: '',
      username: '',
      password: '',
      loginAttempts: 0,
      maxAttempts: 5,
      isExceeded: false,
      isValid: true,
      remoteIP: requestIp.address() || '127.0.0.1',
      remoteAgent: navigator.userAgent,
      adminloginAttempts: 0,
      showCommonLoader: true,
      isRedirectURL: false
    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.handleChange = this.handleChange.bind(this)
  }
  componentWillMount () {
    if(this.props.location.state != null){
      console.log("Redirect URL: ", this.props.location.state.referrer);
      this.setState({isRedirectURL: true});
    }
    let isLoggedIn = this.authService.isLoggedIn()
    if (isLoggedIn) {
      window.location.href = '/welcome';
    } else {
      this.setState({ showCommonLoader: false });
    }
  }
  // Checking the bad login attempts.
  checkAttemptsTimeout () {
    let attemptedDate = new Date(window.localStorage.getItem('loginAttemptsDate'))
    let currentDate = new Date()
    let diff = Math.abs(attemptedDate - currentDate)
    let minutes = Math.floor((diff / 1000) / 60)
    if (minutes > CommonConstants.loginAttempts.checkAttemptsTimeout) {
      this.setState({ loginAttempts: 0, isExceeded: false })
      window.localStorage.setItem('loginAttempts', this.state.loginAttempts)
      window.localStorage.setItem('loginAttemptsDate', null)
    } else {
      let count = window.localStorage.getItem('loginAttempts') ? window.localStorage.getItem('loginAttempts') : 0
      if (count.length > 0) {
        this.setState({ loginAttempts: count })
        if (count === this.state.maxAttempts) {
          this.setState({ isExceeded: true })
        }
      }
    }
  }

  componentDidMount () {
    if (!this.authService.isAdmin()) {
      if (window.localStorage.getItem('loginAttemptsDate')) {
        this.checkAttemptsTimeout()
      } else {
        let count = window.localStorage.getItem('loginAttempts') || 0
        count = parseInt(count, 10)
        if (count > 0) {
          this.setState({ loginAttempts: count })
          if (count === this.state.maxAttempts) {
            this.setState({ isExceeded: true })
          }
        }
      }
    }
  }
  handleChange (e) {
    this.setState(
      {
        [e.target.name]: e.target.value
      }
    )
  }
  // Validating the userlogin.
  validateLogin () {
    let loginAttempts = parseInt(this.state.loginAttempts, 10)
    if (loginAttempts === 4) {
      let count = 0
      count = Number(this.state.loginAttempts)
      count = parseInt(count, 10) + 1
      this.setState({ isValid: false, isExceeded: true, loginAttempts: count })
      window.localStorage.setItem('loginAttempts', count)
      window.localStorage.setItem('loginAttemptsDate', new Date())
    } else {
      let count = 0
      count = Number(this.state.loginAttempts) > 0 ? Number(this.state.loginAttempts) : 0
      count = parseInt(count, 10) + 1
      this.setState({ isValid: false, loginAttempts: count })
      let attempts = this.state.loginAttempts > 0 ? count : 1
      window.localStorage.setItem('loginAttempts', attempts)
    }
  }
  // Handling the form validation.
  handleValidation () {
    let errors = []
    const { language } = this.state
    let username = this.state.username
    let password = this.state.password
    if (username === '' && password === '') {
      errors.push(t[language].usernameinvalid)
      errors.push(t[language].passwordblank)
      this.setState({ username: '', password: '' })
      this.validateLogin()
    } else {
      if (username === '') {
        errors.push(t[language].usernameinvalid)
        this.setState({ username: '', password: '' })
        this.validateLogin()
      }
      if (typeof username !== 'undefined' && username !== '' && !this.authService.isAdmin()) {
        let lastAtPos = username.lastIndexOf('@')
        let lastDotPos = username.lastIndexOf('.')
        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && username.indexOf('@@') === -1 && lastDotPos > 2 && (username.length - lastDotPos) > 2)) {
          errors.push(t[language].usernameinvalid)
          // errors.push(t[language].passwordblank)
          this.setState({ username: '', password: '' })
          this.validateLogin()
        }
      }
      if (password === '') {
        errors.push(t[language].passwordblank)
        this.setState({ username: '', password: '' })
        this.validateLogin()
      }
    }
    this.setState({ errorMessage: errors })
    if (errors.length > 0) {
      this.setState({ isValid: false })
      return false
    }
    this.setState({ isValid: true })
    return true
  }
  // Making a service call to trigger a email for the bad login attempt.
  postBadAttemptLogin () {
    let userInfoRemoteInfo = {
      remoteIP: this.state.remoteIP,
      remoteAgent: this.state.remoteAgent
    }
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.badLoginAttempt
    this.api.postData(url, userInfoRemoteInfo, (result) => {
    })
  }
  // Login form submit.
  submit (e) {
    window.localStorage.removeItem('ctx_token')
    window.localStorage.removeItem('id_token')
    window.localStorage.removeItem('uuid')
    window.localStorage.removeItem('user_email')
    const { language } = this.state
    let user = {
      username: this.state.username.trim(),
      password: this.state.password,
      isAdmin: this.authService.isAdmin()
    }
    if (this.handleValidation()) {
      this.state.showCommonLoader = true
      let url = Config.authBaseUrl + Config.tokenPath
      // Making a service call.
      this.api.postData(url, user, data => {
        // Handling unauthorized user.
        if (data === 'Unauthorized') {
          // Resetting the login form.
          this.setState({ username: '', password: '' })
          this.state.showCommonLoader = false
          this.setState(this.state)
          // Admin
          if (this.authService.isAdmin()) {
            let adminloginAttempts = parseInt(this.state.adminloginAttempts, 10)
            let errors = []
            errors.push(t[language].loginfail)

            if (adminloginAttempts === 4) {
              // Calling a function for the bad login attempt.
              this.postBadAttemptLogin()
              errors.push(t[language].loginattemptinvalid)
              window.localStorage.setItem('adminloginAttempts', this.state.adminloginAttempts)
              this.setState({ adminloginAttempts: 0 })
            } else {
              let count = this.state.adminloginAttempts
              count = parseInt(count, 10)
              this.setState({ isValid: false, errorMessage: errors, adminloginAttempts: count + 1 })
              window.localStorage.setItem('adminloginAttempts', this.state.adminloginAttempts)
            }
          } else {
            // Public user.
            let loginAttempts = parseInt(this.state.loginAttempts, 10)
            if (loginAttempts === 4) {
              let errors = []
              errors.push(t[language].loginfail)
              errors.push(t[language].loginattemptinvalid)
              let count = this.state.loginAttempts
              count = parseInt(count, 10)
              this.setState({ isValid: false, isExceeded: true, errorMessage: errors, loginAttempts: count + 1 })
              window.localStorage.setItem('loginAttempts', this.state.loginAttempts)
              window.localStorage.setItem('loginAttemptsDate', new Date())
              this.postBadAttemptLogin()
            } else {
              let errors = []
              errors.push(t[language].loginfail)
              let count = this.state.loginAttempts
              count = parseInt(count, 10)
              this.setState({ isValid: false, errorMessage: errors, loginAttempts: count + 1 })
              window.localStorage.setItem('loginAttempts', this.state.loginAttempts)
            }
          }
        }
        if (data && data.accessToken) {
          this.authService.setToken(data.accessToken, this.authService.isAdmin())
        }
        if (this.authService.isLoggedIn()) {
          // Resetting the values.
          this.setState({ loginAttempts: 0, adminloginAttempts: 0 })
          window.localStorage.removeItem('user_perm')
          window.localStorage.setItem('loginAttempts', this.state.loginAttempts)
          window.localStorage.setItem('loginAttemptsDate', null)
          if (this.authService.isAdmin()) {
            window.location.href = '/welcome'
          } else {
            // Hanlding DFA - Dual Factor Auth.
            let dfaUrl = Config.apiBaseUrl + CommonConstants.apiUrls.getDFAAccount
            let dfaData = {
              language: this.state.language,
              accountDFAIP: this.state.remoteIP,
              accountDFABrowser: this.state.remoteAgent
            }
            // Checking DFA and Account_TOS_Agree condition.
            this.api.postData(dfaUrl, dfaData, data => {
              let TOSAgree = this.authService.getProfile().Account_TOS_Agree
              if (data.status) {
                if (data.isDFA === 1) {
                  window.location.href = '/validateDfaAuth'
                } else {
                  if (TOSAgree === null || TOSAgree === 0) {
                    if (window.location.pathname !== '/myAccount') {
                      window.location.href = '/myAccount'
                    }
                  } else {
                    if(this.state.isRedirectURL){
                      window.location.href = this.props.location.state.referrer
                    } else {
                      window.location.href = '/welcome'
                    }
                  }
                }
              } else {
                if (TOSAgree === null || TOSAgree === 0) {
                  if (window.location.pathname !== '/myAccount') {
                    window.location.href = '/myAccount'
                  }
                } else {
                  if(this.state.isRedirectURL){
                    window.location.href = this.props.location.state.referrer
                  } else {
                    window.location.href = '/welcome'
                  }
                }
              }
            })
          }
        }
      }, error => {
        console.log(error)
      })
    } else {
      this.state.showCommonLoader = false
    }
  }
  // Handling on enter key for the form submission.
  onEnterPress (e) {
    if (e.key === 'Enter') {
      if (this.handleValidation()) {
        this.setState({ showCommonLoader: true })
        this.submit()
      }
    }
  }
  populateError = (errors) => {
    return errors.map((error, i) => {
      return <li key={i}>{error}</li>
    })
  }
  // Rendering a user form.
  renderUserForm () {
    const { language } = this.state
    return (
      <section>
        {this.state.showCommonLoader ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''}
        <div id='LoginContent' className={this.state.showCommonLoader ? 'hide' : 'show'}>
          <div className='errorMessages'>
            <div className={'alert alert-danger errors ' + (this.state.isValid ? 'hide' : 'show')} >
              <ul> {this.populateError(this.state.errorMessage)}</ul>
            </div>
          </div>
          <div className='appr'>
            <div className={this.state.loginAttempts > 0 ? 'show' : 'hide'}>
              <div className='error'>
                <h4>{t[language].loginattemptsnumber}({this.state.loginAttempts})5</h4>
              </div>
            </div>
            <div className={this.state.loginAttempts === this.state.maxAttempts ? 'show' : 'hide'}>
              <div className='error'>
                <h4>{t[language].loginattemptsexceeded}</h4>
              </div>
            </div>
          </div>
          <div className='forms clear'>
            <div className={this.state.loginAttempts !== this.state.maxAttempts ? 'show' : 'hide'} >
              {this.renderForm()}
            </div>
            <h5 className='forgot_up'><a className='hover' href='/manageAccount/forgotpassword'>{t[language].forgotpass}</a></h5>
          </div>
        </div>
      </section>
    )
  }
  // Admin Login from.
  renderAdminForm () {
    const { language } = this.state
    return (
      <section>
        {this.state.showCommonLoader ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''}
        <div id='LoginContent' className={this.state.showCommonLoader ? 'hide' : 'show'}>
          <div className='adminerrorMessages'>
            <div className={'' + (this.state.isValid ? 'hide' : 'show')} >
              <h3>{t[language].storeSettingsConfirmError} </h3>
              <br />
              <ul> {this.populateError(this.state.errorMessage)}</ul>
            </div>
          </div>
          <div className='forms clear'>
            <div>
              {this.renderForm()}
              <div className='login_reminder'>
                {t[language].login_reminder}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  renderForm () {
    const { language } = this.state
    return (<table className='user_login'>
      <tbody>
        <tr>
          <th><label htmlFor='Username'>{t[language].username}</label></th>
          <td className='loginContents'><input className='loginInputs' type='text' maxLength='100' value={this.state.username} name='username' onChange={this.handleChange.bind(this)} /></td>
        </tr>
        <tr>
          <th><label htmlFor='Password'>{t[language].password}</label></th>
          <td className='loginContents'><input className='loginInputs' type='password' value={this.state.password} maxLength='64' name='password' onChange={this.handleChange.bind(this)} onKeyPress={this.onEnterPress.bind(this)} />
          </td>
        </tr>
        <tr>
          <th />
          <td className='loginContents'><span className='btn_login'><input type='submit' value={t[language].submitBtn} onClick={this.submit.bind(this)} /></span></td>
        </tr>
      </tbody>
    </table>
    )
  }
  // Main Render method.
  render () {
    return (
      <div>
        {this.authService.isAdmin() ? this.renderAdminForm() : this.renderUserForm()}
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Security/Login.js